import styled from "styled-components";

const Header = styled.h2`
  font-size: 50px;
  text-transform: lowercase;
  line-height: 65px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #222;

  @media (max-width: 1199px) {
    font-size: 35px;
    line-height: 50px;
    margin-bottom: 5px;
  }
  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 25px;
  }
`;
export default Header;
